import React from 'react';
import './StartLoader.css';
import {useLoader} from "src/contexts/LoaderContext";

const StartLoader: React.FC = () => {
    const {isStartLoaderVisible} = useLoader();
    return (
        <>
            {isStartLoaderVisible && <div id="configurator-loader">
                <div className="loaderStyle" id="loader1"></div>
                <div className="loaderStyle2" id="loader2"></div>
            </div>}
        </>
    );
};

export default StartLoader;